import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useClose } from '@calendly/ui/components/dropdown';
import { ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerIsSmallPhoneCss = "c1jbepar";
const containerCss = "ch9c90f";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerIsSmallPhoneCss]: isSmallPhone
  }, props.className)} />;
});
const bookmarkButtonIsActiveCss = "bu13iy1";
const bookmarkButtonCss = "bvzp0g7";
const BookmarkButton = forwardRef((props, ref) => {
  const {
    isActive,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(bookmarkButtonCss, {
    [bookmarkButtonIsActiveCss]: isActive
  }, props.className)} />;
});
const Bookmark = ({
  label,
  isActive,
  onClick
}) => {
  const isSmallPhone = useDeviceType('isSmallPhone');
  return <BookmarkButton onClick={onClick} isActive={isActive}>
      {label}
      {isSmallPhone && <ArrowChevronRightMiniIcon />}
    </BookmarkButton>;
};
export const Bookmarks = ({
  onChange,
  period,
  isMIPage
}) => {
  const closePicker = useClose();
  const bookmarks = {
    today: I18n.t('publisher.scheduled_events.filters.today'),
    this_week: I18n.t('publisher.scheduled_events.filters.this_week'),
    this_month: I18n.t('publisher.scheduled_events.filters.this_month')
  };
  if (isMIPage) bookmarks.this_year = I18n.t('publisher.meetings.filter_modal.dates.this_year');else bookmarks.all_time = I18n.t('publisher.routing.forms.responses.filters.date_range.all_time');
  const handleClick = selectedPeriod => {
    onChange({
      period: selectedPeriod
    });
    closePicker();
  };
  return <Container>
      {Object.entries(bookmarks).map(([bookmark, label]) => <Bookmark key={bookmark} label={label} isActive={bookmark === period} onClick={() => handleClick(bookmark)} />)}
    </Container>;
};

require("./bookmarks.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./bookmarks.js");